import { Button, FormGroup, InputLabel, OutlinedInput } from '@mui/material'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import { Container, ContainerForm, Title } from '../../../styles/index.sty';
import AlertSnack from '../../../components/Alert/AlertSnack'
import { useAuth } from '../../../context/authContext'
import { useLists } from '../../../context/listContext'
import { insertSizeData, updateSizeData } from '../../../api/attributes.api'

export const AddSize = () => {
  const { config } = useAuth();
  const { fetchSizesList } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const [ loading, setLoading ] = useState(false);
  const [open, setOpen] = useState(false);
  const [ response, setResponse ] = useState({});
  const formik = useFormik({
    initialValues: {
    size_name: location?.state?.data?.size_name,
    },
    onSubmit: async values => {
      setLoading(true);
      if (location?.state?.data) {
        const submit = await updateSizeData({...values, product_size_id: location?.state?.data?.product_size_id }, config);
        setResponse(submit);
        setOpen(true);
        fetchSizesList();
        if(submit.status === "success") {
          navigate("/sizes");
        }
      } else {
        const submit = await insertSizeData(values, config);
        setResponse(submit);
        fetchSizesList();
        setOpen(true);
        if(submit.status === "success") {
          navigate("/sizes");
        }
      }
    },
  });

  return (
    <>
    <Container>
      <Title variant='h5' className='w-[100%]'>Enter Size Details.</Title>
      <ContainerForm>
      {open && <AlertSnack open={open} setOpen={setOpen} response={response} setLoading={setLoading} route="customers"/>}

      {loading ?
        <div className='items-center'>
          <BeatLoader color="#36d7b7" />
        </div>
        :
      <div style={{width : "60%", margin: "auto"}} >
        <FormGroup>
          <InputLabel htmlFor="size_name">Size Name:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="size_name"
            placeholder="Enter Size Name"
            id="size_name"
            type="text"
            value={formik.values.size_name}
            onChange={formik.handleChange}
            />
        </FormGroup>
        <div className='flex flex-row justify-between'>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={() => navigate("/sizes")}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Back
          </Button>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={formik.handleSubmit}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Save & Continue
          </Button>
        </div>
        </div>}
      </ContainerForm>
    </Container>
    </>
  )
};
